module.exports = __webpack_public_path__ + "img/new_light.ab4afbdc.svg";